import {Icon} from '@wandb/weave/components/Icon';
import {clsx} from 'clsx';
import React, {type ChangeEvent, type FC, useCallback} from 'react';

import {DD_PRIVACY_ALLOW} from '../../util/datadog/privacy';
import {
  useJSONTreeSearchDebouncedContext,
  useJSONTreeSearchInputContext,
} from './JSONTreeSearchContextProvider';

export const SearchInput: FC = () => {
  const {searchQuery, onChangeSearchQuery} = useJSONTreeSearchInputContext();
  const {isSearching} = useJSONTreeSearchDebouncedContext();

  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => onChangeSearchQuery(e.target.value),
    [onChangeSearchQuery]
  );

  return (
    <div
      className={clsx('SearchInput', {isSearching})}
      data-dd-privacy={DD_PRIVACY_ALLOW}>
      <Icon name="search" className="SearchIcon" />
      <input
        type="text"
        tabIndex={0}
        value={searchQuery}
        // data-test="panel-search-input"
        placeholder="Search keys with regex"
        aria-label="search keys with regex"
        onChange={onChange}
      />
    </div>
  );
};
